import { graphql, fetchQuery } from '@boltline/relay-runtime';
import memoize from 'lodash/memoize';

const query = graphql`
  query fetchCertificateTemplateQuery($certificateId: String) {
    certificate(id: $certificateId) {
      name
      templateInfo {
        template
      }
    }
  }
`;

const fetchCertificateTemplate = memoize(async (certificateId) => {
  const result = await fetchQuery(global.relayModernEnvironment, query, { certificateId });
  return result.certificate;
});

export default fetchCertificateTemplate;
